// extracted by mini-css-extract-plugin
export var fadeInDown = "styles-module--fadeInDown--aa7cd";
export var firstGlow = "styles-module--first-glow--f6b1a";
export var showMoreIcon = "styles-module--showMore-icon--39a9a";
export var showMoreText = "styles-module--showMore-text--e4359";
export var showMoreWrapper = "styles-module--showMore-wrapper--8e0ed";
export var suptitle = "styles-module--suptitle--3f741";